export default __webpack_public_path__ + "static/media/aml-policy.455d6f0e.md";